import { Messages } from '../../../../codegen/Localize';
import { IExtractTaskInfo } from '../../../../ts/models/IExtractTaskInfo';
import { SiteRolesResource } from '../../../../ts/resources/SiteRoles';
import { setExtractRefreshPriority } from '../../../actions/spaces/SetExtractRefreshPriorityAction';
import {
  SessionServerSelectors,
  SessionSiteSelectors,
  SessionUserSelectors
} from '../../../selectors/SessionInfoSelectors';
import { AppState } from '../../../state/AppState';
import { EntityActionNames, IEntityAction } from './IEntityAction';

export const SetExtractRefreshPriorityEntityAction: IEntityAction<IExtractTaskInfo, {}> = {
  name: EntityActionNames.TasksPriority,
  translateName: Messages.tasksSetPriority_action,
  isVisible: isVisible,
  isClickable: () => true,
  createReduxAction: setExtractRefreshPriority
};

function isVisible(tasks: IExtractTaskInfo[], state: AppState): boolean {
  return (SessionUserSelectors.isSessionServerAdmin(state) || SiteRolesResource.isSiteAdmin(SessionSiteSelectors.siteRole(state)))
    && !SessionServerSelectors.ignoreExtractTaskPriority(state);
}
